import * as React from 'react';
import { useState } from 'react';

import type { HeadProps, PageProps } from 'gatsby';

import { Link } from 'stile-shared/src/components/2020/common/Link';
import { PageHeading, Section, Text } from 'stile-shared/src/components/2020/common/Primitives';
import { Column } from 'stile-shared/src/components/2020/layout/Column';
import { Grid } from 'stile-shared/src/components/2020/layout/Grid';

import { theme } from 'styles/theme';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

import { TrialFormAu } from 'components/common/TrialFormAu';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Enquire now"
      description="Getting Stile at your school."
      slug={props.location.pathname}
    />
  );
}

function SetUpTrialPage(props: PageProps) {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  return (
    <PageLayout {...props}>
      <Section>
        <Grid min="450px" space={theme.space.xl}>
          <Column>
            <PageHeading>Ready to find out more?</PageHeading>
            <TrialFormAu onSubmissionSuccess={setSubmissionSuccess} />
          </Column>

          {!submissionSuccess && (
            <Column>
              <Text as="h2" size="l" semiBold>
                Getting Stile at your school
              </Text>
              <Text>
                Stile partners with schools to supercharge their existing science programs, or in
                some cases, build a brand new program from the ground-up. Over the years, we’ve
                found the most valuable place to start is to simply have a chat.
              </Text>
              <Text>
                We’re more than happy to put you in touch with a{' '}
                <Link openInNewTab url="/why-choose-stile/what-teachers-are-saying/">
                  school nearby
                </Link>{' '}
                for you to hear about Stile from a colleague first hand.
              </Text>

              <Text as="h2" size="l" semiBold>
                Pricing
              </Text>
              <Text>
                Stile has a simple per-student annual pricing structure. You only pay for the number
                of students you enrol – subscribe for a class, a year level, or your whole school.
                There are no setup fees, data storage is unlimited and teacher accounts are free.
              </Text>
              <Text>
                We really want to help ensure <em>every</em> student has access to a world-class
                science education. If your school loves Stile but can’t afford it, chat to us about
                our Grants and Assistance Program.
              </Text>
            </Column>
          )}
        </Grid>
      </Section>
    </PageLayout>
  );
}

export default SetUpTrialPage;
